import { Typography } from "@mui/material";
import PageContainer from "./PageContainer";

const AniCamp = () => {
  return (
    <PageContainer>
      <Typography variant="h4">Game Stats Coming Soon...</Typography>
    </PageContainer>
  );
};

export default AniCamp;
